import { apiClient } from "@/services/apiClient";

/**
 * Stop and resume work on a request.
 *
 * Exists because auto-verifying a bank transfer establishes that the receipt
 * MATCHED, not that the money arrived. Between those two claims someone has to
 * look at the bank statement, and until they have, the platform needs a way to
 * halt work that is already moving — without losing where it had got to.
 *
 * Kept out of platformBankTransfersService because these are `/platform/requests`
 * endpoints on the fulfillment side: the transfer queue is the first caller, not
 * the owner.
 */
export type PausableRequestChannel = "notary" | "accountant";

/**
 * Halt a request. The reason is shown to the professional, so work that
 * suddenly stops accepting actions is never unexplained.
 */
export function pauseRequest(
  channel: PausableRequestChannel,
  requestId: string,
  reason?: string,
): Promise<{ ok: true }> {
  return apiClient
    .post<{ ok: true }>(`/platform/requests/${channel}/${requestId}/pause`, { reason })
    .then((res) => res.data);
}

/** Let work continue. The request resumes exactly where it stopped. */
export function unpauseRequest(
  channel: PausableRequestChannel,
  requestId: string,
): Promise<{ ok: true }> {
  return apiClient
    .post<{ ok: true }>(`/platform/requests/${channel}/${requestId}/unpause`, {})
    .then((res) => res.data);
}
